import { BrowserSupport } from '../modules/BrowserSupport';

// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2

export const getDeviceId = (track: MediaStreamTrack): string | undefined => {
  if (typeof track?.getCapabilities === 'function') {
    return track?.getCapabilities().deviceId;
  }

  // Fallback for older browsers (e.g. Firefox ESR 128)
  return track?.getSettings().deviceId;
};

export const isBackgroundEffectSupported = (): boolean => {
  //theoretically we could separate blurring and background image if we use this check
  //safari does not support filter but we could use background image in safari
  const currentBrowser = new BrowserSupport();
  return !currentBrowser.isSafari();
};
